// External Dependencies
import styled, { useTheme } from 'styled-components';
import ListItemIcon from '@mui/material/ListItemIcon';
import type { FC } from 'react';
import type { OverridableComponent } from '@mui/material/OverridableComponent';
import type { SvgIconTypeMap } from '@mui/material/SvgIcon';

// Local Typings
interface Props {
  icon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>>;
  iconColor?: string;
  isActive?: boolean;
}

// Local Variables
const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    minWidth: theme.spacing(6),
  },
  '.MuiSvgIcon-root': {
    [theme.breakpoints.down('md')]: {
      height: 22,
      width: 22,
    },
  },
}));

// Component Definition
const EnhancedMenuItemLeftIcon: FC<Props> = ({
  icon: Icon,
  iconColor,
  isActive,
}) => {
  const { palette: { prestoPrimaryLight } } = useTheme();

  return (
    <StyledListItemIcon>
      <Icon
        htmlColor={iconColor
          || (isActive
            ? prestoPrimaryLight
            : iconColor)}
      />
    </StyledListItemIcon>
  );
};

export default EnhancedMenuItemLeftIcon;
